import script from "./rank.vue?vue&type=script&setup=true&lang=js"
export * from "./rank.vue?vue&type=script&setup=true&lang=js"

import "./rank.vue?vue&type=style&index=0&id=646eb24e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-646eb24e"]])

export default __exports__